import { fromJS } from 'immutable'

export default fromJS({
  questions: {
    noAlt: 'Thiếu văn bản thay thế cho hình ảnh này',
    noAnswers: 'Không có tùy chọn trả lời, vui lòng nhấn tiếp theo để tiếp tục.',
    placeholder: 'Vui lòng nêu rõ......',
    pleaseSelect: 'Vui lòng chọn...',
    rotateLandscape: 'Vui lòng tắt Khóa xoay trên điện thoại của bạn và xoay sang ngang để tiếp tục.',
    rotatePortrait: 'Hãy xoay điện thoại của bạn từ phong cảnh sang chân dung để tiếp tục.',
    ir: {
      selectWebCam: 'Chọn webcam (nếu có) hoặc nhấn “Duyệt” để tải lên từ thiết bị của bạn',
      uploadOnly: 'hoặc nhấn “Duyệt” để tải lên từ thiết bị của bạn',
      noWebCam: 'Không tìm thấy webcam',
      accessCamUpload: 'TRUY CẬP CAMERA/TẢI LÊN',
      browse: 'DUYỆT',
      uploadPhoto: 'Tải lên hình ảnh',
      camera: 'Webcam',
      instead: 'thay vì',
      capture: 'CHỤP',
      somethingWrong: 'Rất tiếc, đã xảy ra lỗi. Vui lòng thử lại sau',
      couldntRead: 'Rất tiếc, chúng tôi không thể đọc mã!',
      couldntProcess: 'Rất tiếc, chúng tôi không thể xử lý ảnh của bạn!',
      inValidCode: 'Vui lòng gửi mã hợp lệ',
      moveOn: 'Vui lòng thử lại hoặc gửi ảnh của bạn và tiếp tục',
      tryAgain: 'Vui lòng thử lại',
      dataReceived: 'Đã nhận được dữ liệu!',
      enterManually: 'Vui lòng thử lại hoặc nhập dữ liệu theo cách thủ công bên dưới',
      positionQR:
        'Vui lòng đặt mã QR ở phía trước camera sao cho vừa với khung màu đỏ hoặc tải lên mã này từ máy tính của bạn.',
      positionQRMobile: 'Vui lòng đặt mã QR trước camera hoặc tải lên từ thiết bị của bạn.',
      analyzing: 'Đang phân tích ảnh, vui lòng chờ',
      submit: 'GỬI',
      startOver: 'Bắt đầu lại',
      allDone: 'Hoàn tất!',
      cantAnalyze:
        'Chú ý - chúng tôi không thể kết xuất hình ảnh này. Hãy thử gửi lại hoặc chọn định dạng hình ảnh phổ biến hơn (JPG, PNG, GIF, BMP)',
      wrongFormat:
        'Rất tiếc - chúng tôi không hỗ trợ định dạng tập tin này. Vui lòng tải lên định dạng hình ảnh được hỗ trợ (JPG, PNG, GIF, BMP, TIF, PDF, SVG)'
    },
    vr: {
      noWebCam: 'Không tìm thấy webcam',
      uploadVideo: 'Tải lên video',
      skip: 'Bỏ qua?',
      accessCamUpload: 'TRUY CẬP CAMERA/TẢI LÊN',
      browse: 'DUYỆT',
      instead: 'thay vì',
      or: 'hoặc',
      stopRecording: 'Dừng quay',
      willBeStopped: 'Sẽ dừng quay sau  <b>5 phút</b>',
      stopOnDone: 'Dừng quay khi bạn đã làm xong!',
      record: 'quay',
      somethingWrong: 'Rất tiếc, đã xảy ra lỗi. Vui lòng thử lại sau',
      dataReceived: 'Đã nhận được dữ liệu!',
      microphone: 'micrô',
      camera: 'Webcam',
      selectMicrophone: 'Chọn micrô của bạn',
      selectCam: 'Chọn webcam của bạn',
      submit: 'GỬI',
      upload: 'TẢI LÊN',
      playback: 'Phát lại',
      stopPlayback: 'DỪNG PHÁT LẠI',
      startOver: 'Bắt đầu lại',
      allDone: 'Hoàn tất!',
      alternativeRecordSpan: 'Vui lòng tải lên một đoạn video từ máy tính của bạn.  <br/>Ngoài ra, bạn có thể &nbsp;',
      alrenativeRecordHref: 'quay video bằng webcam.',
      cantAnalyze:
        'Chú ý - chúng tôi không thể kết xuất video này. Hãy thử gửi lại hoặc chọn định dạng video phổ biến hơn (MP4, M4V, WEBPM)',
      wrongFormat:
        'Rất tiếc - chúng tôi không hỗ trợ định dạng tập tin này. Vui lòng tải lên định dạng video được hỗ trợ (MP4, AVI, M4V, WEBPM, MOV, MKV, MPG, WMV)'
    },
    cjc: {
      choose: 'CHỌN',
      pleaseChoose: 'Vui lòng',
      this: 'chọn',
      one: ' một',
      myChoice: 'LỰA CHỌN của tôi'
    },
    hm: {
      addComment: 'Vui lòng thêm nhận xét vào bên dưới',
      commentMandatoryPlaceHolder: 'Vui lòng thêm nhận xét bắt buộc... ',
      commentOptionalPlaceHolder: 'Vui lòng thêm nhận xét tùy chọn... ',
      dragPin: 'Kéo để xác định lại vị trí (nhấn/chạm và giữ lâu để ghim chính xác).',
      removePin: 'Kéo ra ngoài hình ảnh để xóa.',
      editComment: 'Nhấn/chạm vào dấu ghim để chỉnh sửa nhận xét.',
      addPin: 'Vui lòng kéo ghim từ bảng điều khiển bên dưới và thả vào vị trí mà bạn chọn trên hình ảnh.',
      addPins: 'Vui lòng kéo các ghim từ bảng điều khiển bên dưới và thả vào vị trí mà bạn chọn trên hình ảnh.',
      leavePins: (minPoints, maxPoints) =>
        `Vui lòng để lại ít nhất ${minPoints}, ghim nhưng không quá ${maxPoints} ghim mỗi loại.`,
      leavePinsAny: (minPoints, maxPoints) =>
        `Vui lòng để lại ít nhất ${minPoints}, ghim nhưng không quá ${maxPoints} ghim của bất kỳ loại nào.`,
      leavePinsPerPage: (minPoints, maxPoints) =>
        `Vui lòng để lại ít nhất ${minPoints}, ghim nhưng không quá ${maxPoints} ghim.`,
      leavePinsWithOff: maxPoints => `Vui lòng để lại không quá ${maxPoints} ghim mỗi loại nhấn Tiếp theo để tiếp tục.`,
      leavePinsWithOffAny: maxPoints =>
        `Vui lòng để lại không quá ${maxPoints} ghim của bất kỳ loại nào nhấn Tiếp theo để tiếp tục.`,
      leavePinsPerPageWithOff: maxPoints => `Vui lòng để lại không quá ${maxPoints} ghim nhấn Tiếp theo để tiếp tục.`,
      leavePinWithOff: `Vui lòng để lại không quá 1 ghim mỗi loại hoặc nhấn Tiếp theo để tiếp tục.`,
      leavePinWithOffAny: `Vui lòng để lại không quá 1 ghim của bất kỳ loại nào hoặc nhấn Tiếp theo để tiếp tục.`,
      leavePinPerPageWithOff: 'Vui lòng để lại không quá 1 ghim của bất kỳ loại nào hoặc nhấn Tiếp theo để tiếp tục.',
      leaveExactlyPin: `Vui lòng để lại 1 ghim mỗi loại.`,
      leaveExactlyPinAny: `Vui lòng để lại 1 ghim của bất kỳ loại nào.`,
      leaveExactlyPinPerPage: 'Vui lòng để lại 1 ghim.',
      leaveExactlyPins: maxPoints => `Vui lòng ${maxPoints} ghim mỗi loại.`,
      leaveExactlyPinsAny: maxPoints => `Vui lòng ${maxPoints} ghim của bất kỳ loại nào.`,
      leaveExactlyPinsPerPage: maxPoints => `Vui lòng ${maxPoints} ghim.`,
      leaveComment: 'Nhập bên dưới hình ảnh và để lại nhận xét.',
      noAnswers: 'Không có tùy chọn trả lời, vui lòng nhấn tiếp theo để tiếp tục.',
      outOfPins: 'Bạn đã hết ghim',
      pinsBehavior: 'Khi di chuyển qua hình ảnh, bạn sẽ thấy các khu vực được đánh dấu bằng một dấu ghim.',
      clusters: 'Bạn sẽ chỉ có thể đặt ghim vào những khu vực được đánh dấu này.',
      contentAware: 'Bạn có thể thả ghim vào bên trong hoặc bên ngoài các khu vực được đánh dấu.'
    },
    mp: {
      expand_note: 'Vui lòng di chuột hoặc nhấn vào hình ảnh để mở rộng.',
      rb_note: rows => `Vui lòng chỉ chọn 1 câu trả lời cho mỗi mục bên${rows ? ' dưới' : ''}:`,
      cb_note: (min, max, rows) => {
        if (min === max) {
          return `Vui lòng ${min !== 1 ? 'chọn' : 'chỉ chọn'} ${min} câu trả lời bất kỳ cho mỗi mục bên${
            rows ? ' dưới' : ''
          }:`
        } else if (min > 0 && max < 5000) {
          return `Vui lòng chọn ít nhất ${min} câu trả lời nhưng không quá ${max} cho mỗi mục bên${
            rows ? ' dưới' : ''
          }:`
        } else if (5000 === max && min > 0) {
          return `Vui lòng chọn ít nhất ${min} câu trả lời cho mỗi mục bên${rows ? ' dưới' : ''}:`
        } else if (0 === min && max < 5000) {
          return `Vui lòng chọn không quá ${max} câu trả lời cho mỗi mục bên${rows ? ' dưới' : ''}:`
        } else {
          return 'Đánh dấu tất cả những ý đúng:'
        }
      }
    },
    sh: {
      note: 'Nhấn vào một sản phẩm để phóng to và thêm vào giỏ hàng ảo nếu bạn muốn mua nó tại cửa hàng',
      amazonNote: 'Nhấn vào một sản phẩm để phóng to và thêm vào giỏ hàng ảo nếu bạn muốn mua nó trực tuyến',
      fullCart: 'Giỏ hàng của bạn đã đầy!',
      qty: 'SỐ LƯỢNG',
      addToCart: 'THÊM VÀO GIỎ HÀNG',
      deleteFromCart: 'XÓA',
      each: 'mỗi',
      items: 'mặt hàng',
      emptyCard: 'Giỏ hàng của bạn đang trống',
      total: 'Giỏ hàng',
      clearCart: 'Xóa giỏ hàng',
      scrollError: `Vui lòng cuộn hết sang trái và phải để tiếp tục khảo sát. `,
      backToStore: 'Kembali ke kedai',
      na: 'Không có ý nào ở trên',
      next: 'TIẾP THEO'
    },
    rb: {
      note: 'Vui lòng chỉ chọn 1 mục:'
    },
    vo: {
      note: 'Vui lòng xem hết video'
    },
    cb: {
      note: (min, max) => {
        if (1 === min && 5000 === max) {
          return 'Đánh dấu tất cả những ý đúng:'
        } else if (min === max) {
          return `Vui lòng ${min !== 1 ? 'chọn' : 'chỉ chọn'} ${min} mục:`
        } else if (min > 0 && max < 5000) {
          return `Vui lòng chọn ít nhất ${min} mục, ghim nhưng không quá ${max}:`
        } else if (5000 === max && min > 0) {
          return `Vui lòng chọn ít nhất ${min} mục:`
        } else if (0 === min && max < 5000) {
          return `Vui lòng nhưng không quá ${max} mục:`
        } else {
          return 'Đánh dấu tất cả những ý đúng:'
        }
      }
    },
    oe: {
      na: 'Không áp dụng',
      note: (min, max, optional) => {
        if (min === max) {
          return `Vui lòng ${1 !== min ? 'chọn' : 'chỉ chọn'} ${min} ký tự${optional ? ' (không bắt buộc)' : ''}:`
        } else if (min > 0 && max < 5000) {
          return `Vui lòng chọn ít nhất ${min} ký tự ghim nhưng không quá ${max}${optional ? ' (không bắt buộc)' : ''}:`
        } else if (5000 === max && min > 0) {
          return `Vui lòng chọn ít nhất ${min} ký tự${optional ? ' (không bắt buộc)' : ''}:`
        } else if (0 === min && max < 5000) {
          return `Vui lòng nhưng không quá ${max} ký tự${optional ? ' (không bắt buộc)' : ''}:`
        } else {
          return ''
        }
      }
    },
    oex: {
      note: 'Vui lòng điền vào các trường sau đây:'
    },
    mx: {
      note: 'Hãy di chuyển các thanh trượt được đánh dấu để tiếp tục',
      dragSlider: 'Kéo sang trái hoặc phải để trả lời'
    },
    psc: {
      dragLeftRight: 'Kéo sang trái hoặc phải để trả lời'
    },
    ps: {
      note: value => `Vui lòng phân phối ${value} còn lại giữa các mục bên dưới`,
      allDone: `Hoàn tất`,
      total: `tổng cộng:`,
      dragSlider: 'Kéo sang trái hoặc phải để trả lời'
    },
    cx: {
      note: 'Mở ô thả xuống và bắt đầu nhập câu trả lời của bạn để tự động cuộn hoặc chọn thủ công'
    },
    ro: {
      note: 'Kéo lên hoặc xuống để sắp xếp lại:'
    },
    md: {
      note1: 'Vui lòng nhấn/chạm vào mục mà bạn chọn đầu tiên<br/> Nhấn/chạm lại để xóa lựa chọn',
      note2: 'Bây giờ hãy nhấn/chạm vào mục mà bạn chọn cuối cùng <br/> Nhấn/chạm lại để xóa lựa chọn.',
      note3: 'Xin cảm ơn! Tiếp tục đến câu hỏi tiếp theo hoặc nhấn/chạm vào bất kỳ mục chưa chọn nào để bắt đầu lại.'
    },
    aro: {
      note: 'Vui lòng chọn một mục từ mỗi cặp'
    },
    wd: {
      note: 'Đảm bảo mỗi giá trị tiếp theo phải lớn hơn giá trị trước đó.'
    },
    emd: {
      note: 'Vui lòng xem hết video',
      noAnswers: 'Không có tùy chọn trả lời, vui lòng nhấn tiếp theo để tiếp tục.',
      start: 'Nhấn và giữ để bắt đầu',
      resume: 'Nhấn và giữ để tiếp tục',
      continue: 'Bạn đã sẵn sàng! Nhấn Tiếp theo để tiếp tục',
      continueMobile: 'Bạn đã sẵn sàng! Nhấn VÀO ĐÂY để tiếp tục',
      training: {
        session: 'Phiên đào tạo',
        note: 'Vui lòng hoàn thành đào tạo',
        moveLeft: 'Vui lòng kéo mặt quay sang bên trái',
        moveBottom: 'Vui lòng kéo mặt quay xuống dưới cùng',
        moveRight: 'Bây giờ hãy kéo mặt quay sang bên phải',
        moveTop: 'Bây giờ hãy kéo mặt quay lên trên cùng',
        success: 'Tuyệt!'
      }
    },
    sft: {
      noAnswers: 'Không có tùy chọn trả lời, vui lòng nhấn tiếp theo để tiếp tục.',
      note: 'Hãy trả lời nhanh nhất có thể với đáp án mà trực giác của bạn cảm thấy đúng',
      imageError: 'No image exposure time chosen',
      finish: 'Bạn đã hoàn thành! Vui lòng nhấn Tiếp theo để tiếp tục',
      training: {
        start:
          '<p>Câu hỏi này sẽ cho bạn xem nhanh các từ khác nhau và bạn sẽ cần phải tập trung.</p><p>Bạn sẵn sàng thực hành chưa?</p>',
        step1: (touch, mouse, key) =>
          touch
            ? `Chạm "{buttonLeft}"`
            : (mouse ? `Nhấn "{buttonLeft}"` : '') +
              (key && mouse ? ' / ' : '') +
              (key ? `Nhấn phím "{keyBtnLeft}"` : ''),
        step2: (touch, mouse, key) =>
          touch
            ? `Chạm "{buttonRight}"`
            : (mouse ? `Nhấn "{buttonRight}"` : '') +
              (key && mouse ? ' / ' : '') +
              (key ? `Nhấn phím "{keyBtnRight}"` : ''),
        fail: () => 'Quá chậm',
        success: () => 'Tuyệt!',
        finish: () =>
          '<p><strong> Xuất sắc!</strong></p><p>Đảm bảo bạn không <br />' +
          'được mất tập trung<br/> trong 2-3 phút tiếp theo</p><p>Nhấn Tiếp theo để bắt đầu khi bạn sẵn sàng.</p>'
      },
      buttons: {
        start: 'Bắt đầu',
        yesno: {
          left: 'Đúng',
          right: 'Không'
        },
        matches: {
          left: 'Khớp',
          right: 'Không khớp'
        },
        fits: {
          left: 'Vừa',
          right: 'Không vừa'
        },
        thumbs: {
          left: '<i class="rfd-ui-button-icon icon-aytmfd-thumbsUp"></i>',
          right: '<i class="rfd-ui-button-icon icon-aytmfd-thumbsDown"></i>'
        },
        noyes: {
          left: 'Đúng',
          right: 'Không'
        },
        matchesRev: {
          left: 'Khớp',
          right: 'Không khớp'
        },
        fitsRev: {
          left: 'Vừa',
          right: 'Không vừa'
        },
        thumbsRev: {
          left: '<i class="rfd-ui-button-icon icon-aytmfd-thumbsUp"></i>',
          right: '<i class="rfd-ui-button-icon icon-aytmfd-thumbsDown"></i>'
        }
      }
    }
  }
})
